<template>
  <Layout>
    <template v-slot:left>
      <ButtonBackList
        :toUrl="toUrl"
        :isReadOnly="form.basicSetting.isReadOnly"
      />
      <ButtonCopy @click="onCopyClicked" />
    </template>
    <template v-slot:right>
      <ButtonPrev />
      <ButtonNext :form="form" />
    </template>
  </Layout>
</template>

<script>
import ButtonBackList from '@/components/Shared/Simulation/SimulationFooterButtonBackList'
import ButtonNext from '@/components/Shared/Simulation/SimulationFooterButtonNext'
import ButtonPrev from '@/components/Shared/Simulation/SimulationFooterButtonPrev'
import ButtonCopy from '@/components/Shared/Simulation/SimulationFooterReadonlyButtonCopy'
import Layout from '@/components/Shared/Simulation/SimulationFooterLayout'
import accountApi from '@/api/account'
import AdvertiserApi from '@/api/AdvertiserApi'

export default {
  name: 'SimulationFooterReadonly',
  components: {
    ButtonBackList,
    ButtonNext,
    ButtonPrev,
    ButtonCopy,
    Layout,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toUrl: undefined,
    }
  },
  async mounted() {
    this.toUrl = await this.getSimulationListUrl()
  },
  methods: {
    fetchAdvertiser() {
      return AdvertiserApi.fetchAdvertiser(this.belongId).then(res => res.item)
    },
    async getBelongInfo() {
      const accountInfo = await accountApi.getMe()
      return accountInfo.item
    },
    async onCopyClicked() {
      const belongInfo = await this.getBelongInfo()
      if (belongInfo.belongType === 'advertiser') {
        this.belongId = belongInfo.belongId
        await this.redirectAdvertiserSimulationAdd()
        return false
      }
      this.redirectLoginLPSimulationAdd()
    },
    redirectLoginLPSimulationAdd() {
      this.$router.push({
        name: 'LoginLpSimulationAdd',
        params: {
          passedForm: this.form,
        },
      })
    },
    async redirectAdvertiserSimulationAdd() {
      const { agencyId } = await this.fetchAdvertiser()

      this.$router.push({
        name: 'SimulationAdd',
        params: {
          agencyId: agencyId,
          advertiserId: this.belongId,
          passedForm: this.form,
        },
      })
    },
    async getSimulationListUrl() {
      if (this.$route.path !== '/simulations/readonly') {
        return '../../simulations'
      }
      const belongInfo = await this.getBelongInfo()
      if (belongInfo.belongType !== 'advertiser') {
        return '/loginlp/simulations'
      }
      const advertiserId = belongInfo.belongId
      const advertiserInfo = await AdvertiserApi.fetchAdvertiser(advertiserId)
      const agencyId = advertiserInfo.item.agencyId
      return `/agencies/${agencyId}/advertisers/${advertiserId}/simulations`
    },
  },
}
</script>

<style scoped>
.buttons {
  margin: 5px 10px;
}
</style>
